import { Component } from 'react';
import { object, shape, bool } from 'prop-types';
import connector from './connector';

/**
 * This modal is now deprecated and just redirects to PreviewModal
 * which now includes the upload functionality directly.
 * Keeping this for backwards compatibility with existing code that opens it.
 */
class AcknowledgementCreate extends Component {
  componentDidUpdate(prevProps) {
    const { isOpen, actions } = this.props;

    // When this modal is opened, close it immediately and open the preview modal
    if (isOpen && !prevProps.isOpen) {
      actions.acknowledgmentCreateModal.close();
      actions.acknowledgmentPreviewModal.open();
    }
  }

  render() {
    // This modal no longer renders anything, it just redirects
    return null;
  }
}

AcknowledgementCreate.propTypes = {
  isOpen: bool.isRequired,
  actions: shape({
    acknowledgmentCreateModal: object.isRequired,
    acknowledgmentPreviewModal: object.isRequired,
  }).isRequired,
};

export default connector(AcknowledgementCreate);
